 /*=========================================================================================
  File Name: actions.js
  Description: Hub Actions
  ----------------------------------------------------------------------------------------
  Item Name: Hub Module
  Author: Tan Tran
==========================================================================================*/
import hubService from '../../../services/communication/hub.js'
import state from './state.js';

export default {
    async connectToHubServerAction ( {commit, state, rootState }, payload ) {

        let token = rootState.auth.token;


        if (token != null) {
            
            let hub = hubService.createHubConnection(token);
            
            await hub.start()
                           .then(() => {
                                console.log('Hub is connected!');
                                commit('SET_HUB_CONNECTION_STATE', {'hub' : hub, 'isConnected' : true});
                           })
                           .catch(
                               console.log('Cannot connect to hub!')
                           )
        }
    },

    async registerToServerEventAction ( {commit, state, rootState }, payload ) {

        let restaurantId = rootState.auth.restauratId;

        if (state.isConnected) {
            await state.hub.invoke('AddToGroup', restaurantId)
                            .then(() => {
                                console.log('Client is registered to group!');
                            }) 
                            .catch(err => console.log('Cannot register to group!'));
        }
    },

    async unregisterToServerEventAction( { commit }, payload ) {
        
        let restaurantId = rootState.auth.restauratId;

        if(state.isConnected) {
            await state.hub.invoke('RemoveFromGroup', restaurantId)
                            .then( () => {
                                console.log('Client is unregistered to group') 
                            })
                            .catch(err => console.log(err));
        }

    }
}